import React, { useState } from "react";
import logo from "../assets/wondercoms-logo-green.png";
import { Link, NavLink } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="wc-header">
      <div className="wc-header-inner">
        <Link to="/" className="wc-logo" aria-label="WonderComs ホーム" onClick={closeMenu}><img src={logo} alt="WonderComs" /></Link>
        <button className="wc-menu-toggle" type="button" aria-expanded={menuOpen} aria-controls="wc-navigation" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? "閉じる" : "メニュー"}<span aria-hidden="true">{menuOpen ? "×" : "☰"}</span></button>
        <nav id="wc-navigation" className={`wc-navigation${menuOpen ? " is-open" : ""}`} aria-label="メインナビゲーション" onKeyDown={(event) => { if (event.key === "Escape") closeMenu(); }}>
          <NavLink to="/service" activeClassName="is-current" onClick={closeMenu}>サービス</NavLink>
          <NavLink to="/company" activeClassName="is-current" onClick={closeMenu}>会社概要</NavLink>
          <NavLink to="/news" activeClassName="is-current" onClick={closeMenu}>お知らせ</NavLink>
          <NavLink to="/contact" activeClassName="is-current" className="wc-nav-contact" onClick={closeMenu}>お問い合わせ <span aria-hidden="true">↗</span></NavLink>
        </nav>
      </div>
    </header>
  );
}
